module.exports = __webpack_public_path__ + "static/uni_fisk-27ae921459c2868a4dbd98adc72d188d.png";